var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "process-wrapper" }, [
    _c("div", { staticClass: "process-line" }, [
      _c("span", {
        staticClass: "icon",
        class: {
          active: _vm.active === "createAccount",
          finish: _vm.active !== "createAccount"
        }
      }),
      _c("span", {
        staticClass: "line",
        class: { finish: _vm.active !== "createAccount" }
      }),
      _c("span", {
        staticClass: "icon",
        class: {
          active: _vm.active === "record",
          default: _vm.active !== "record"
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "words" }, [
      _c("span", { staticClass: "setting" }, [
        _vm._v(_vm._s(_vm.$t("settingAcc")))
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "record" }, [
        _vm._v(_vm._s(_vm.$t("mnemonic.record")))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }